/* @flow */

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

export const index = ctx => {
  const root = document.getElementById('root');
  if (root) {
    ReactDOM.render(<App user={ctx.params.id} />, root);
  }
};



// WEBPACK FOOTER //
// ./src/modules/my-space/index.js